import style from './index.module.scss';
import merber from '@/images/transfer/merber.jpg';
import back from '@/images/transfer/back.png';
import { Toast } from 'antd-mobile';
import { isHdl, HRouter, commonBridge } from '@haidilao-private/jsbridge';
import { APPID_MERBER } from '@/helper/common/constant';
const { REACT_APP_API_ENV = 'pro' } = process.env;

interface APPInformationProps {
  APPVersion?: string;
  phoneVersion?: string;
  systemVersion?: string;
}

const TransferMerber = () => {
  const compareVersions = (oldVer_: string, newVer_: string) => {
    const oldVersions: string[] = oldVer_.split('.');
    const newVersions: string[] = newVer_.split('.');

    const minL = Math.min(newVersions.length, oldVersions.length);
    let pos = 0; // 当前比较位
    let diff = 0; // 当前为位比较是否相等
    // 逐个比较如果当前位相等则继续比较下一位
    while (pos < minL) {
      diff = parseInt(newVersions[pos]) - parseInt(oldVersions[pos]);
      if (diff !== 0) {
        break;
      }
      pos++;
    }
    // 1是新版本  2是版本相等  3是旧版本
    if (diff > 0) {
      return '1';
    } else if (diff === 0) {
      if (newVersions.length > oldVersions.length) {
        return '1';
      } else {
        return '2';
      }
    } else {
      return '3';
    }
  };

  const onTransfer = () => {
    if (isHdl) {
      commonBridge(
        'webGetAPPInformation',
        {},
        (res: APPInformationProps | null) => {
          if (compareVersions('8.3.0', res?.APPVersion || '') < '3') {
            commonBridge('launchMiniprogram', {
              path: '/activePackage/pages/privateDomain/welfare/index',
              userName: APPID_MERBER,
              miniprogramType: REACT_APP_API_ENV == 'pro' ? '0' : '2',
            });
          } else {
            Toast.show({
              content: '此版本无法支持该功能，请更新到最新版本',
            });
          }
        }
      );
    } else {
      Toast.show({
        content: '请在海底捞app中打开',
      });
    }
  };

  const onBack = () => {
    HRouter.back();
  };

  return (
    <div className={style.transferBox}>
      <img className={style.transferImg} src={merber} alt="" />
      <div className={style.backBox} onClick={onBack}>
        <img className={style.backs} src={back} />
      </div>
      <div className={style.transferbtn} onClick={onTransfer}></div>
    </div>
  );
};
export default TransferMerber;
